<!--
component: KamiInformationInput
author: Izumi
description: 台帳情報入力画面
-->
<template>
	<body style="height: 100%;">
		<!-- データ入力時の台帳参照ウィンドウ -->
		<container class="scroll-container" style="width: 100%; height: calc(100% - 50px);">
			<div class="scroll-container" ref="container" @wheel.prevent="handleWheel" style="width: 100%; height: 100%;">
				<div class="image-wrapper" :style="{ transform: `translate(${translateX}px, ${translateY}px) scale(${scale})` }" style="width: 100%; height: 100%;">
					<img :src="imageUrl" alt="Image" class="full-width-image" ref="image" @mousedown="handleMouseDown" @mousemove="handleMouseMove" @mouseup="handleMouseUp" @mouseleave="handleMouseUp">
				</div>
			</div>
		</container>

			<container class="button-container">
				<div class="button-container-right">
					<div style="margin-right: 5px;"> {{currentFileName}} </div>
					<div style="margin-right: 5px;">
						<button class="action-button" @click="rotateLeft">
							左回転
						</button>
						<button class="action-button" @click="rotateRight">
							右回転
						</button>
					</div>
					<!--
					<button class="action-button" @click="printImage">
						画像印刷
					</button>
					-->
				</div>
			</container>

	</body>
</template>
  
<script>
//import MapComponent from '../components/Map.vue'

export default {
	data() {
		return {
			rotationAngle: 0,
			
			//------------------------------------
			// Zoom
			isDragging: false,
			startX: 0,
			startY: 0,
			translateX: 0,
			translateY: 0,
			scale: 1,
			//------------------------------------
		}
	},
	components: {
		//    MapComponent,
	},
	props: ['image'],
	created() {
	},
	mounted() {
	},
	computed: {
    imageUrl() {
      return decodeURIComponent(this.image); // URL エンコードされたパラメーターをデコードする
    },
		token() {
			return this.$store.state.token;
		},
		unauthorized() {
			return this.token == undefined || this.token == null || this.token.length == 0;
		},
		authorized() {
			return !this.unauthorized;
		},
		message: {
			get() { return this.$store.state.message; },
			set(val) { this.$store.commit('setMessage', val); }
		},
		browsable() {
			return this.isSelected && this.existsGaiyo;
		},
		features: {
			get() { return this.$store.state.features; },
			set(val) { this.$store.commit('setFeatures', val); }
		},
		sheets: {
			get() { return this.$store.state.sheets; }
		},
		mode() {
			return this.$store.state.mode;
		},
		authority() {
			//return this.$store.state.authority;
			return this.$store.state.userInfo.authority;
		},
		sheetVisible() {
			//return (this.authority >= 1) && (this.mode == 1 || this.mode == 5);
			// authority=4 は住所検索と番号検索のみ（仮）
			return (this.authority >= 1 && this.authority != 4) && (this.mode == 1 || this.mode == 5);
		},
		douroShubetsuVisible: {
			get() {
				return this.$store.state.douroShubetsuVisible;
			},
			set(val) {
				this.$router.commit('setDouroShubetsuVisible', val);
			}
		},
	},
	watch: {
	},
	methods: {
		printImage() {
			const url = this.imageUrl();
			const rotationAngle = this.rotationAngle;

			var printFrame = document.createElement('iframe');
			printFrame.style.display = 'none';

			printFrame.onload = function() {
				var imageContainer = printFrame.contentDocument.querySelector('div');
        imageContainer.style.display = 'flex';
        imageContainer.style.margin = 0;
        imageContainer.style.justifyContent = 'center';
        imageContainer.style.alignItems = 'center';
        imageContainer.style.height = '100vh';
        //imageContainer.style.width = '100%';
        //imageContainer.style.height = '100%';

				//var style = printFrame.contentDocument.createElement('style');
				//style.innerHTML = '@media print { @page { size: landscape; } }';
				//printFrame.contentDocument.head.appendChild(style);

				var image = printFrame.contentDocument.querySelector('img');
				image.style.maxWidth = '100%';
        image.style.maxHeight = '100%';
        image.style.transform = `rotate(${rotationAngle}deg)`;
//		一時的に追加
				printFrame.contentWindow.print();
				document.body.removeChild(printFrame);
			};

			document.body.appendChild(printFrame);

			printFrame.contentDocument.write('<html><head><title>Print Image</title></head><body style="margin: 0; text-align: center;"><div><img src="' + url + '" style="max-width: 100%; max-height: 100%;"></div></body></html>');
			printFrame.contentDocument.close();

			// ページ読み込み完了後に印刷を開始します
	//		一時的に876行目に追加
	//		printFrame.contentWindow.print();
	//		document.body.removeChild(printFrame);
		},
		rotateRight() {
			this.rotationAngle += 90;
			this.rotateImage();
		},
		rotateLeft() {
			this.rotationAngle -= 90;
			this.rotateImage();
		},
		rotateImage() {
			const image = this.$refs.image;
					//const wrapper = image.parentElement;

					//this.adjustImageSize(image, wrapper);
			image.style.transform = `rotate(${this.rotationAngle}deg)`;
		},
		adjustImageSize(image, wrapper) {
			if (this.rotationAngle % 180 === 90) {
				wrapper.style.width = `${image.clientHeight}px`;
				wrapper.style.height = `${image.clientWidth}px`;
			} else {
				wrapper.style.width = '';
				wrapper.style.height = '';
			}
		},
		//------------------------------------
		// Zoom
		handleMouseDown(event) {
			event.preventDefault();
			
			this.isDragging = true;
			this.startX = event.clientX - this.$refs.container.offsetLeft;
			this.startY = event.clientY - this.$refs.container.offsetTop;
		},
		handleMouseMove(event) {
			if (!this.isDragging) return;
			const offsetX = event.clientX - this.startX;
			const offsetY = event.clientY - this.startY;
			this.translateX += offsetX;
			this.translateY += offsetY;
			this.startX = event.clientX;
			this.startY = event.clientY;
			},
		handleMouseUp() {
			this.isDragging = false;
		},
		handleWheel(event) {
			const delta = Math.sign(event.deltaY);
			const scaleFactor = 0.1;
			this.scale -= (delta * scaleFactor);
			this.scale = Math.max(0.6, this.scale);
		},
		toggleLock() {
			this.isLock = !this.isLock;
		},
	}
}
</script>
  
<style lang="scss" scoped>
@import "../styles/common/common.css";
@import "../styles/split-alt.css";

body {
	align-items: flex-start;
	/* 左寄せに設定 */
	height: 100vh;
	/* 画面の高さいっぱいに広がるように */
	padding-left: 10px;
	padding-right: 10px;
	margin: 0;
	/* ボディのマージンをゼロに設定 */
	background-color: #E0E0E0;
	/* グレーの背景色 */
	white-space: nowrap;
	/* テキストを改行させないようにする */
	overflow: hidden;
	/* コンテンツがコンテナをはみ出た場合に隠す */
}

container {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	flex-direction: row;
	max-width: auto;
	margin-right: 5px;
	text-align: left;
	font-size: 14px;
}

.right-align-container {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-right: 5px;
}

section {
	display: flex;
	justify-content: space-between;
	/* または space-evenly を使用する */
	align-items: flex-start;
	/* 左寄せに設定 */
	flex-direction: column;
	max-width: auto;
	/* 任意の横幅に設定 */
	margin-right: 5px;
	text-align: auto;
	/* 左寄せに設定 */
	font-size: 14px;
}

p {
	background-color: #70d8e4;
	/* 任意の色を指定 */
	width: 100%;
	margin-bottom: 0px;
}

thead {
	background-color: rgb(56, 110, 155);
	color: mintcream;
}

.split {
	//height: 100%;
	height: calc(100% - 12px);
	padding: 6px 0;
}

.right-box {
	right: 0;
	width: 30%;
	//height: 100%;
	height: calc(100% - 24px);
	margin: 4px 0;
	overflow-y: auto;
	background-color: rgb(118, 164, 170);
}

.acceptButton {
	font-size: 2rem;
	padding: 0.5em 1.5em;
}

/*
  .selected {
	background-color: rgb(238, 255, 0);
  }
  */
#selected-plot {
	background-color: lightsteelblue;
	font-size: 1.25rem;
	width: 100%;
	margin: 0.5em 0;
	text-align: center;
}

::v-deep .v-bottom-sheet {
	height: 30%;
}

.v-dialog__content {
	z-index: 2 !important;
}

/* 操作部分 */
.button-background {
	width: 100%;
	background: linear-gradient(to bottom, #b0b0b0, #d1d1d1);
}

.button-container {
	display: flex;
	justify-content: space-between;
	/* アイテムを横方向に左寄せに配置 */
	background: linear-gradient(to bottom, #b0b0b0, #d1d1d1);
	padding: 5px;
}

.button-container-right {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-left: auto;
	background: linear-gradient(to bottom, #b0b0b0, #d1d1d1);
	padding: 5px;
}

.action-button {
	position: relative;
	background: linear-gradient(to bottom, #d1d1d1, #b0b0b0);
	color: #000000;
	border: 1px solid #808080;
	/* ボーダーのスタイルと色 */
	height: 30px;
	padding-left: 20px;
	/* 左側のpadding */
	padding-right: 20px;
	/* 右側のpadding */
	margin-right: 1px;
	/* 仕切りとの間隔 */
	margin-bottom: 0px;
	/* 下部の余白を解除 */
	display: inline-flex;
	/* インラインフレックスコンテナにする */
	align-items: center;
	/* 垂直方向に中央揃え */
	cursor: pointer;
}

.action-button[disabled] {
	background: linear-gradient(to bottom, #d1d1d1, #b1b1b1);
	color: #8c8c8c;
}

.action-button::after {
	content: "";
	position: absolute;
	top: 0;
	right: -2px;
	/* 仕切りの太さ */
	height: 100%;
	width: 2px;
	/* 仕切りの幅 */
	background-color: #7a7a7a;
	/* 仕切りの色 */
}

.action-button:hover {
	background-color: #7c7c7c;
	/* カーソルが乗った時の背景色 */
}

.right-slide {
	margin-left: auto;
}

/* テキストボックス */
.textbox {
	background-color: #ffffff;
	width: 100%;
	/* ボックスの幅 */
	height: 26px;
	padding: 10px;
	/* テキストとボックスの内側の余白 */
	border: 1px solid #808080;
	/* ボーダーのスタイルと色 */
	border-radius: 3px;
	/* 角の丸み */
	font-size: 14px;
	/* テキストのサイズ */
	-moz-appearance: textfield;
}

.textbox:focus {
	border-color: #007bff;
	/* フォーカス時のボーダーの色 */
	outline: none;
	/* デフォルトのフォーカス時のアウトラインを無効にする */
}

.textbox[disabled] {
	background-color: #f0f0f0;
	/* ロックされているときの背景色 */
	color: #777;
	/* ロックされているときの文字色 */
	cursor: not-allowed;
	/* ロックされているときのカーソルスタイル */
}

.textbox::-webkit-outer-spin-button,
.textbox::-webkit-inner-spin-button {
	-webkit-appearance: none;
	/* ChromeやSafariでの矢印を非表示にする */
	margin: 0;
	/* 矢印があった場所の余白を取り除く */
}

/* プルダウン */
select {
	width: 100%;
	padding: 4px;
	/* セレクトボックス内のコンテンツと枠の間に余白を作る */
	border: 1px solid #808080;
	/* ボーダーのスタイルと色 */
	background-color: white;
	/* セレクトボックスの背景色を白にする */
	cursor: pointer;
}

select[disabled] {
	background-color: #f0f0f0;
	/* ロックされているときの背景色 */
	color: #777;
	/* ロックされているときの文字色 */
	cursor: not-allowed;
	/* ロックされているときのカーソルスタイル */
}

.custom-select {
	position: relative;
	display: inline-block;
}

.custom-select select {
	min-width: 40px;
	width: 100%;
	padding: 5px;
	font-size: 14px;
	border: 1px solid #808080;
	border-radius: 3px;
	background-color: #fff;
	appearance: none;
	/* デフォルトの矢印を非表示にする */
}

.custom-select::after {
	content: '\25BC';
	/* 下向きの三角矢印のUnicode */
	font-size: 7px;
	position: absolute;
	top: 50%;
	right: 7px;
	transform: translateY(-50%);
	pointer-events: none;
	/* 矢印はクリックイベントを受けないようにする */
}


/* チェックボックス */
.checkbox {
	margin-right: 5px;
	transform: scale(1.5);
}

/* データ入力時の台帳参照ウィンドウ */

.image-wrapper {
  display: inline-block;
}

.full-width-image {
	width: 100%;
	height: 100%;
  height: auto;
  position: absolute;
	margin: 0 auto;
	object-fit: contain; /* 縦横比を保って表示 */
}

.fullscreen-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.fullscreen-content {
  text-align: center;
}

.fullscreen-image {
  max-width: 100%;
  max-height: 100%;
}

.combob {
	min-width: 40px;
	width: 100%;
	padding: 5px;
	font-size: 14px;
	border: 1px solid #808080;
	border-radius: 3px;
	background-color: #fff;
	appearance: none;
	/* デフォルトの矢印を非表示にする */
}

.combob::after {
	content: '\25BC';
	/* 下向きの三角矢印のUnicode */
	font-size: 7px;
	position: absolute;
	top: 50%;
	right: 7px;
	transform: translateY(-50%);
	pointer-events: none;
	/* 矢印はクリックイベントを受けないようにする */
}

.scroll-container {
  overflow: hidden;
  width: 500px; /* 画像の初期幅 */
  height: 400px; /* 画像の初期高さ */
  border: 1px solid #808080;
  position: relative;
}
.image-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  transition: transform 0.3s ease; /* スムーズな移動を追加 */
}
.full-width-image {
  display: block;
  width: 100%;
  height: auto;
  cursor: grab; /* ドラッグカーソル */
}
label {
  cursor: pointer;
}





/* ラジオボタン項目 */
.input-hidden {
  visibility: hidden;
  position: absolute;
}

.input-hidden:checked + .action-button {
  background: linear-gradient(to bottom, #949494, #a3a3a3); 
  color: #000000;
}
</style>
  
